import { useQuery } from '@apollo/client';
import type { UseAccountOptionsFetch } from '@openx/components-segment/lib/utils/context/SegmentHookTypes.ts';
import { ACL_TYPE } from '@openx/types/aclType.ts';
import { useMemo } from 'react';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';

export const useAccountOptionsFetch: UseAccountOptionsFetch = () => {
  const { data: { account = [] } = {}, loading, refetch } = useQuery(GetOrganizationsListDocument);

  const mapById = useMemo(
    () =>
      account.reduce((acc, account) => {
        acc[account.id] = { id: account.id, name: account.name };
        return acc;
      }, {}),
    [account]
  );

  const lalEnabledAccounts = useMemo(
    () =>
      account.reduce((acc, _account) => {
        const isLalEnabled = _account.exchange_account_network?.acl?.[ACL_TYPE.LOOKALIKE_SEGMENTS_ENABLED] ?? false;

        if (isLalEnabled) {
          acc[_account.id] = { id: _account.id, name: _account.name };
        }

        return acc;
      }, {}),
    [account]
  );

  return {
    accounts: {
      lalEnabledAccounts,
      list: account,
      loading,
      mapById,
      refetch,
    },
  };
};
